import { useContext } from "react";
import { PageProps } from "../../../models/routing.model";
import ParticipantDashboardBiometrics from "./biometrics/ParticipantDashboardBiometrics";
import { ParticipantContextProps } from "../../../models/contexts/participant-context.model";
import { ParticipantContext } from "../../../contexts/Participant.context";
import MedicationsQuickView from "./medications/MedicationsQuickView";
import ParticipantOverview from "./ParticipantOverview";
import RequiresAttentionQuickView from "./requires-attention/RequiresAttentionQuickView";
import ConditionsQuickView from "./conditions/ConditionsQuickView";
import ParticipantNotes from "./notes/ParticipantNotes";
import ChecklistsQuickView from "./checklists/ChecklistsQuickView";
import PostDischargeQuickView from "./post-discharge/PostDischargeQuickView";
import TagsQuickView from "./tags/TagsQuickView";

const ParticipantDashboard = (props: PageProps) => {
	const participantContext = useContext<ParticipantContextProps>(ParticipantContext);
	const participantProfile = participantContext.participant!;

	return (
		<div className="pt-dashboard">
			<div className="pt-dashboard__main">
				{/* Participant overview */}
				<ParticipantOverview />

				{/* Participant notes */}
				<ParticipantNotes />
			</div>

			<div className="pt-dashboard__sidebar">
				<ul>
					{/* Requires attention */}
					<li>
						<RequiresAttentionQuickView participantId={participantProfile.id} />
					</li>

					{/* Tags */}
					<li>
						<TagsQuickView participantId={participantProfile.id} />
					</li>

					{/* Conditions */}
					<li>
						<ConditionsQuickView participantId={participantProfile.id} />
					</li>

					{/* Biometrics */}
					<li>
						<ParticipantDashboardBiometrics participantId={participantProfile.id} />
					</li>

					{/* Medications */}
					<li>
						<MedicationsQuickView participantId={participantProfile.id} />
					</li>

					{/* Checklists */}
					<li>
						<ChecklistsQuickView patientId={participantProfile.id} />
					</li>

					{/* Post Discharge */}
					<li>
						<PostDischargeQuickView patientId={participantProfile.id} />
					</li>
				</ul>
			</div>
		</div>
	);
};
export default ParticipantDashboard;
